export const rowPerPageOptions = [10, 15, 30, 50, 100, 200, 300, 500, 1000, 2000, 5000, 10000, 15000, 30000];
